import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { FreeBetWinningType, gameConfigStore, getAmountWithCurrency } from '@pascal/pascal-core';
import { doBetStore, oddStore } from '../../../../store';

export const CurrentAmount = observer(({ betAmount, isHalfCashOutOn, isHalfCashOuted, index }) => {
  const amount = isHalfCashOuted ? betAmount / 2 : betAmount;
  const [winAmount, setWinAmount] = useState(betAmount);
  const { oddData, isMaxWin, setIsMaxWin, isFreeBetMaxWin, setFreeBetMaxWin } = oddStore;
  const { currentFreeBetMaxPayout, currentMaxWin, freeBetType } =
    doBetStore.doBetSectionsData[index];
  const currentWinAmount =
    freeBetType === FreeBetWinningType.Win ? amount * oddData - amount : amount * oddData;
  const {
    limits: { maxWin },
  } = gameConfigStore;

  const maxWinAmount = currentFreeBetMaxPayout || maxWin;
  const maxWinLimit = currentMaxWin || maxWinAmount;

  useEffect(() => {
    if (currentWinAmount > maxWinLimit) {
      if (winAmount < maxWinLimit) {
        setWinAmount(maxWinLimit);
      }

      if (!isFreeBetMaxWin[index] && currentFreeBetMaxPayout) {
        setWinAmount(maxWinLimit);
        setFreeBetMaxWin(true, index);
      }

      if (!isMaxWin[index] && !currentFreeBetMaxPayout) {
        setWinAmount(maxWinLimit);
        setIsMaxWin(true, index);
      }
    } else {
      setWinAmount(currentWinAmount);
    }
  }, [oddData]);

  return isHalfCashOutOn ? (
    <p className='half-cashout-amount'>
      {getAmountWithCurrency({
        amount: (+winAmount).toFixed(2),
      })}
    </p>
  ) : (
    <span className='cashout-amount'>
      {getAmountWithCurrency({
        amount: (+winAmount).toFixed(2),
      })}
    </span>
  );
});
